import axios from 'axios'
import resolveRequest from '../../utils/resolveRequest.js'
import { apiEndpoints, SERVER_PATH } from '../endpoints.js'

export default async (campaignObject) => {
  const endpoint = `${apiEndpoints.campaigns}`
  const URL = SERVER_PATH + endpoint
  return resolveRequest(axios.post(URL, campaignObject, { withCredentials: true }))
}
